import { Typography } from "@mui/material";
import React from "react";
import SectionHeader from "./SectionHeader";
import DetailCaption from "./DetailCaption";

function WhatToLeave() {
  return (
    <>
      <SectionHeader>Radios, MP3 players, magazines, instruments</SectionHeader>
      <DetailCaption>
        Please refrain from the use of games, musical instruments, and
        electronics at Singing School.
      </DetailCaption>
      <Typography variant="body2">
        This guideline is sometimes overlooked since the introduction of closed
        campers. Not only are these things distracting to you and others, but
        one of the greatest enhancements to being at Harmony Hill is the
        opportunity to live “unplugged” for the week.
      </Typography>
    </>
  );
}

export default WhatToLeave;
